import { Component } from '@angular/core';

@Component({
  selector: 'app-building-icon',
  templateUrl: './building-icon.component.html',
  styleUrl: './building-icon.component.scss'
})
export class BuildingIconComponent {

}
